import { Middleware } from '@reduxjs/toolkit'
import { crsApi } from '../api/crs/react'

const authMiddleware: Middleware = () => (next) => (action) => {
  if (
    crsApi.endpoints.userLogin.matchFulfilled(action) ||
    crsApi.endpoints.verifyMfaCode.matchFulfilled(action) ||
    crsApi.endpoints.verifyBackupCode.matchFulfilled(action) ||
    crsApi.endpoints.manageProfile.matchFulfilled(action) ||
    crsApi.endpoints.resetPassword.matchFulfilled(action) ||
    crsApi.endpoints.accountsProfile.matchFulfilled(action)
  ) {
    if (action?.payload?.results) localStorage.setItem('USER', JSON.stringify(action.payload.results))
  }
  if (crsApi.endpoints.userLogout.matchPending(action)) {
    localStorage.removeItem('USER')
  }
  return next(action)
}

export default authMiddleware
